import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.changeHandler = (e) => this.updateStatus(e);
    this.element.querySelectorAll(".user-status").forEach((item) => {
      item.addEventListener("change", this.changeHandler);
    });
  }

  disconnect() {
    this.element.querySelectorAll(".user-status").forEach((item) => {
      item.removeEventListener("change", this.changeHandler);
    });
  }

  updateStatus(e) {
    e.preventDefault();
    const userId = e.target.dataset.userId;
    const userStatus = e.target.value;
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;

    fetch(`/users/${userId}/update`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
      },
      body: JSON.stringify({ user: { status: userStatus } }),
    }).catch(() => {
      alert("Failed to update user status. Please try again.");
    });
  }
}
